/**
 * Where a session lives in the app. The organizer's slug is preferred so a shared link reads as
 * the session rather than as a uuid, and the id is the fallback for one that has no slug yet.
 *
 * It is one function because five screens and the calendar export all build this link, and a
 * calendar entry that outlives the event must not point at a path this app later renames.
 */
export function sessionPath(session: { id: string; slug?: string | null }): string {
  return `/program/${session.slug ?? session.id}`;
}
